// Use an immediately invoked function expression (IIFE) to create a closure
(function () {
  window.colorsData = window.colorsData || {};

  async function preLoadSwatches() {
    try {
      let colors = document.querySelectorAll('.cusSwatchesBody .swatchesPanel-item__link, .cusSwatchesBody .color-swatch-link');
      
      if (colors.length === 0) {
        console.warn('No color swatches found');
        return;
      }

      // No await - fetches run in parallel but function doesn't wait
      Array.from(colors).forEach((color) => {
        if (!color.href || window.colorsData[color.href]) return;
        
        fetch(color.href)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            window.colorsData[color.href] = text;
          })
          .catch((error) => {
            console.error('Failed to load color:', color.href, error);
          });
      });
    } catch (error) {
      console.error('Error in preLoadSwatches:', error);
    }
  }

  // Private variable, not accessible from outside this scope
  let swatchRequestInProgress = false;
  window.productNavigationUrl = `${window.location.pathname}${window.location.search}`;

  function swatchesModalOpen(title) {
    const selectedPrintImg = document.querySelector(`.swatchesHoverUniqueImage[data-title="${title}"]`)?.getAttribute('data-src');
    if (!selectedPrintImg) {
      return;
    }
    let imgFirstSpl;
    let imgSecSpl;
    let finalImageUrl;
    const fileExtensions = ['.jpg', '.png', '.jpeg'];
    const selectedExtension = fileExtensions.find((ext) => selectedPrintImg.includes(ext));
    let aspectRatio = `_400x`;
    if (selectedExtension) {
      imgFirstSpl = selectedPrintImg.split(selectedExtension)[0];
      imgSecSpl = selectedPrintImg.split(selectedExtension)[1];

      finalImageUrl = `${imgFirstSpl}${selectedExtension}${imgSecSpl}`;
      if (finalImageUrl.includes('_400x')) {
        finalImageUrl = finalImageUrl;
      } else {
        finalImageUrl = `${imgFirstSpl}${aspectRatio}${selectedExtension}${imgSecSpl}`;
      }
    }
    document.querySelector(`.swatches-modal[data-title="${title}"] img`).src = finalImageUrl;
  }

  function updateOtherSections(doc) {
    try {
      const newArrivalsSection = document.querySelector('.section-new-arrivals');
      if (newArrivalsSection) {
        newArrivalsSection.innerHTML = doc.querySelector('.section-new-arrivals').innerHTML;
      }

      const loveThisPrintSection = document.querySelector('.section-love-this-print');
      if (loveThisPrintSection) {
        loveThisPrintSection.innerHTML = doc.querySelector('.section-love-this-print').innerHTML;
      }

      initProductListSlider();
      initColorSwatchSlider();
    } catch (error) {
      console.error('Error updating other sections:', error);
    }
  }

  async function colorSwatchPDPChange(event) {
    event.preventDefault();

    const mainProductContainer = document.querySelector('product-info');
    const link = event.currentTarget.closest('a');

    console.log('event', event.currentTarget.closest('a'));

    console.log('colorSwatchPDPChange', link);

    try {
      const url = link.href;

      const linkUrl = new URL(url);
      const linkPath = linkUrl.pathname;

      if (linkPath === window.location.pathname) return;

      // Prevent multiple simultaneous swatch changes
      if (swatchRequestInProgress) return;

      // Add loading indicator to the product container
      if (!mainProductContainer) {
        swatchRequestInProgress = false;
        return;
      }

      mainProductContainer.classList.add('loading');

      let colorHtml = window.colorsData[url];

      if (!colorHtml) {
        const colorResponse = await fetch(url);
        if (!colorResponse.ok) {
          throw new Error(`HTTP error! status: ${colorResponse.status}`);
        }

        colorHtml = await colorResponse.text();
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(colorHtml, 'text/html');

      const newMainProduct = doc.querySelector('product-info');
      const productMedia = newMainProduct.querySelector('.product__media-wrapper');

      const quickAddModals = document.querySelectorAll('.quick-add-modal');
      quickAddModals.forEach((modal) => {
        modal.remove();
      });

      if (newMainProduct && mainProductContainer) {
        const producModal = document.getElementById(`ProductModal-${mainProductContainer.dataset.section}`);
        if (producModal) producModal.remove();

        // Get important data attributes before replacing content
        const oldUrl = mainProductContainer.dataset.url;
        const oldProductId = mainProductContainer.dataset.productId;
        const oldSection = mainProductContainer.dataset.section;

        // Change URL without reloading the page
        window.history.pushState({ path: url }, '', url);
        window.productNavigationUrl = `${window.location.pathname}${window.location.search}`;

        // Replace the content
        mainProductContainer.innerHTML = newMainProduct.innerHTML;

        // Restore important data attributes
        mainProductContainer.dataset.url = newMainProduct.dataset.url || oldUrl;
        mainProductContainer.dataset.productId = newMainProduct.dataset.productId || oldProductId;
        mainProductContainer.dataset.section = oldSection;

        // Re-initialize the nedia slider
        mainProductContainer.initializeMediaGallery();

        // Reinitialize pdpScrollAndPlay functionality after content replacement
        // Use setTimeout to ensure DOM is fully updated
        setTimeout(() => {
          if (window.initPdpScrollAndPlay) {
            window.initPdpScrollAndPlay();
          }
        }, 100);

        // Reinitialize Yotpo widgets
        if (window.yotpo) {
          window.yotpo.refreshWidgets();
        }

        updateOtherSections(doc);

        // // Trigger Easy Size readiness event
        // window.dispatchEvent(new Event('easySizeReady'));
      }
    } catch (error) {
      console.error('Error in colorSwatchPDPChange:', error);
    } finally {
      // Reset loading states
      if (mainProductContainer) {
        mainProductContainer.classList.remove('loading');
      }
      swatchRequestInProgress = false;
    }
  }

  // Expose these functions to the global scope
  window.swatchesModalOpen = swatchesModalOpen;
  window.colorSwatchPDPChange = colorSwatchPDPChange;

  preLoadSwatches();

  window.addEventListener('popstate', function () {
    const currentProductUrl = `${window.location.pathname}${window.location.search}`;
    const productUrlChanged = currentProductUrl !== window.productNavigationUrl;
    window.productNavigationUrl = currentProductUrl;

    // Hash-only changes (Rivo #rivo-favorites, in-page anchors) fire popstate
    // in Chrome but are not color-swatch back/forward. Do not reload those.
    if (!productUrlChanged) return;

    location.reload();
  });
})();
